import { FC, Fragment } from 'react'
import { Field } from 'formik'
import { StyleFormWrapper, StyleLabel } from '../style'
import ErrorMessage from '../ErrorMessage'
import {
  StyleGroupCheckboxItems,
  StyleGroupCheckboxItem,
  StyleCheckbox,
  StyleCheckboxLabel,
} from './style'
interface GroupCheckBoxProps {
  name: string
  label?: string
  options: Array<any>
  valueAsKey: string
  titleAsKey: string
  styleWrapper?: string
  styleLabel?: string
  styleItem?: string
  multiple?: boolean
}

const GroupCheckBox: FC<GroupCheckBoxProps> = ({
  label,
  name,
  options,
  styleWrapper,
  styleLabel,
  valueAsKey,
  titleAsKey,
  styleItem,
  multiple = true,
}) => {
  const handleCheckboxChange = ({ e, field, form }: any) => {
    const value = e.target.value
    if (!value) return
    if (!!multiple) {
      let newValue = Array.isArray(field.value) ? [...field.value] : []
      if (e.target.checked) {
        if (!newValue.includes(value)) {
          newValue.push(value)
        }
      } else {
        newValue = newValue.filter((v) => v !== value)
      }
      form.setFieldValue(name, newValue)
    } else {
      form.setFieldValue(name, value)
    }
  }
  return (
    <Field name={name} styleWrapper={styleWrapper}>
      {({ field, meta, form }) => {
        const hasError = meta.touched && meta.error
        return (
          <StyleFormWrapper>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}
            <StyleGroupCheckboxItems
              onChange={(e: any) => {
                handleCheckboxChange({
                  e,
                  field,
                  form,
                })
              }}
            >
              {options?.map((option, index) => {
                return (
                  <Fragment key={index}>
                    <StyleGroupCheckboxItem styleItem={styleItem}>
                      <StyleCheckbox
                        type="checkbox"
                        value={option[valueAsKey]}
                        checked={
                          !!multiple
                            ? field.value?.includes(option[valueAsKey])
                            : field.value == option[valueAsKey]
                        }
                        readOnly
                      />
                      <StyleCheckboxLabel>
                        {option[titleAsKey]}
                      </StyleCheckboxLabel>
                    </StyleGroupCheckboxItem>
                  </Fragment>
                )
              })}
            </StyleGroupCheckboxItems>
            {!!hasError && <ErrorMessage message={meta.error} />}
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default GroupCheckBox
